// extracted by css-extract-rspack-plugin
export default {"cls1":"YourPaperCard-cls1_5Vf","cls2":"YourPaperCard-cls2_iH_ YourPaperCard-cls1_5Vf"};